import { Component, Input } from '@angular/core';
import { PermitAreaProperties } from '../../../span-progress-entities';

@Component({
  selector: 'app-permit-area-popup-content',
  templateUrl: './permit-area-popup-content.component.html',
  styleUrls: ['./permit-area-popup-content.component.scss'],
  standalone: false,
})
export class PermitAreaPopupContentComponent {
  @Input() properties: PermitAreaProperties;

  get statusTranslation() {
    return 'permitAreaPopup.' + this.properties.status;
  }
}
